import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';

import Modal from 'react/components/Modal';
import { getResourceTo } from 'react/utils/utils';
import { LookupField, GroupField, TextField } from 'react/components/fields';

const UserTagFieldsModal = ({ closeModalFn, modalIsOpen, idpName }) => {
  const buttonLabel = getResourceTo('samlConfiguration.button.close');
  const userTagModalSubtitle = getResourceTo('userTagModal.label.subtitle');

  const Footer = () => (
    <>
      <input type="button" value={buttonLabel} onClick={closeModalFn} />
    </>
  );

  return (
    <Modal
      className="fieldMappingModal"
      isOpen={modalIsOpen}
      title={getResourceTo('userTagModal.label.title')}
      closeModalFn={closeModalFn}
      crossAxisBtn={false}
      footer={<Footer />}
    >
      <p className="fieldMappingModal-label">{userTagModalSubtitle}</p>
      <GroupField name="idp.tagMappings">
        <TextField
          label={getResourceTo('samlConfiguration.indentityProviderUserTag', idpName)}
          description="assertionFieldName"
          name="assertionFieldName"
        />
        <div className="arrowRight" />
        <LookupField
          label="samlConfiguration.greenmileUserTag"
          name="value"
          lookupEntity="Tag"
          lookupEntityColumn="description"
        />
      </GroupField>
    </Modal>
  );
};

const selector = formValueSelector('SamlConfiguration');

UserTagFieldsModal.propTypes = {
  closeModalFn: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  idpName: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  modalIsOpen: state.samlConfiguration.getIn(
    ['modals', 'userTag', 'modalIsOpen'],
    false
  ),
  idpName: selector(state, 'idp.idpName')
});

export default connect(mapStateToProps)(React.memo(UserTagFieldsModal));
